import React, {useState, useEffect}  from "react";
import { Body1Stronger, TableCell } from '@fluentui/react-components';
import EntryCell from "./EntryCell";
import { format, endOfWeek, isWithinInterval, addDays } from "date-fns";
import {useGlobalStatus} from '../../services/GlobalStatusProvider';

export default function WeekRow(props) {   
    const{ currentWeekStart }= useGlobalStatus();
    const [total, setTotal]=useState("");   

    const handleEntryCellAction = (day) => {
        calculateTotal(props.data, day);
        props.handleEntryCellAction(props.data, day);
    }

    const calculateTotal = (data, day) => {
        var exclude;
        if(day==null) exclude = new Date(1900,1,1);
        else exclude = day.date;
        
        var validDays = data.entryDays.filter(q=> q.status!=='empty' && q.status!=='error' && q.date!== exclude && 
            isWithinInterval(q.date, {start: currentWeekStart, end: addDays(endOfWeek(currentWeekStart),1)}));
        setTotal(validDays.reduce( function(total, item){                
                return total + (
                    item.entries.reduce(function(dayTotal, entry){
                        return dayTotal + entry.totalMinutes;
                    },0));
            }, 
        0));     
    }
    
    useEffect(() => {
        calculateTotal(props.data);
    });

    return (
        <>
        {props.data.entryDays.map((day)=>{
                return (
                        <EntryCell 
                            key={`${props.keybase}-d${format(day.date,'yyyyMMdd')}`} 
                            handleEntryCellAction={handleEntryCellAction} 
                            data={day}
                        />
                )                
        })}  
        <TableCell style={{backgroundColor: '#F3F3F3'}}>
        <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
            <Body1Stronger>{(Math.round(total / 60 * 100) / 100).toFixed(2)}hr</Body1Stronger>
        </div> 
        </TableCell>
        </>
    )
}